module.exports = __webpack_public_path__ + "img/back-img1.94e46ac9.png";